import { render } from "./ball-numbers.vue?vue&type=template&id=887fe0da&scoped=true"
import script from "./ball-numbers.vue?vue&type=script&lang=js"
export * from "./ball-numbers.vue?vue&type=script&lang=js"

import "@/assets/scss/common/ball/ball-numbers.scss?vue&type=style&index=0&id=887fe0da&scoped=true&lang=scss"

import exportComponent from "/Users/thanhnguyen/Desktop/ThanhNguyen/projects/public_html/numbers-betting-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-887fe0da"]])

export default __exports__